<template>
  <div class="country-upsert-form">
    <div class="input-group">
      <dg-input type="text" v-model="formData.name" placeholder="Name" />
      <dg-input type="text" v-model="formData.alpha2Name" placeholder="ISO 3166-1 alpha-2 country code" />
      <picker
        :api="$api.currencies.index"
        v-model="formData.currencyId"
        value-key="id"
        placeholder="Select base currency" />

      <el-button type="primary" icon="el-icon-upload" @click="handleAction">Save</el-button>
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'CountryUpsertForm',
  components: { Picker },
  props: {
    country: {
      type: Object
    }
  },
  data () {
    return {
      formData: {
        name: '',
        currencyId: '',
        alpha2Name: ''
      }
    }
  },
  methods: {
    handleAction () {
      if (this.country) {
        this.update()
      } else {
        this.add()
      }
    },
    async add () {
      const response = await this.$http.post(this.$api.countries.add, this.formData)
      this.$message.success('Country added successfully')
      this.$emit('add', response.data)
    },
    async update () {
      const response = await this.$http.put(this.$api.countries.update(this.country.id), this.formData)
      this.$message.success('Country updated successfully')
      this.$emit('update', response.data)
    }
  },
  created () {
    if (this.country) {
      this.formData.currencyId = this.country.currency ? this.country.currency.id : null
      this.formData.name = this.country.name
      this.formData.alpha2Name = this.country.alpha2Name
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/countries/UpsertForm.vue